import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TmpWtFinished } from '../../../shared/components/templates/tmp-wt-finished/tmp-wt-finished';
import { ActivatedRoute } from '@angular/router';
import { RdGameService } from '../../../shared/services/games/rd-game';
import { PlayersService } from '../../../shared/services/players/players';
import { TmpWtPlayersInfo } from '../../../shared/components/templates/tmp-wt-players-info/tmp-wt-players-info';
import { Subscription, timer } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { InfoQuestRole } from '../../../shared/dialogs/info-quest-role/info-quest-role';
import { AllStatus } from '../../../core/services/status/all-status';
import { AppShared } from '../../../shared/components/shared/app-shared/app-shared';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { ExitService } from '../../../core/services/exit/exit.service';
import { FieldBuilder } from '../../../shared/services/fields/field-builder';

@Component({
  selector: 'app-lobby',
  imports: [TmpWtFinished, TmpWtPlayersInfo, TranslatePipe, AppShared],
  templateUrl: './lobby.html',
  styleUrl: './lobby.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Lobby implements OnInit, OnDestroy{
  activatedRoute = inject(ActivatedRoute);
  allStatus = inject(AllStatus);
  fieldBuilder = inject(FieldBuilder);
  uuid: string;
  rdUse = inject(RdGameService);
  players = inject(PlayersService);
  realPlayers: any = [];
  roomInfo: any;

  questInfo:any;
  readonly dialog = inject(MatDialog);

  subscription: Subscription;
  subscriptionDW: Subscription;
  subscriptionCM: Subscription;
  subscriptionTM: Subscription;
  subscriptionCL: Subscription;
  whenRefresh$ = timer(1000, 1500);
  whenRefreshTM$ = timer(0, 1000);

   exit = inject(ExitService);

  constructor( private ref: ChangeDetectorRef){}
  
  ngOnInit(): void {
    this.uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
    this.allStatus.setChangeUuId(this.uuid);
    this.questInfo = JSON.parse(sessionStorage.getItem('QuestInfo') as string);
    this.rdUse.gameInfoById(this.uuid);

    if(typeof this.players.player === 'undefined'){
      this.players.getPlayerStorage();
    }

    this.activatedRoute.data.subscribe(({ room, players })=>{
      this.players.players = players.players;
      this.roomInfo = room.room;
      this.fieldBuilder.loadPlayingField(this.roomInfo.not_empty);
    });

    this.subscriptionDW = this.allStatus.downTime$.subscribe((follow: any)=>{
          if(follow){
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'nutri-templs';
            dialogConfig.backdropClass = 'nutri-templs-backdrop';
    
            const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
            dialogRef.afterClosed().subscribe(result=>{
              this.players.detelePlayerByPage(this.activatedRoute.snapshot.paramMap.get('id') as string);
              this.exit.exitSystem();
            });
          }
        });

    this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
          this.updateDeteilQuest();
      }
    });

    this.updateAllInfo();
    
  }
  updateDeteilQuest() {
    this.updateQuestInfo();
    setTimeout(() => {
      if(this.subscriptionTM){
        this.subscriptionTM.unsubscribe();
      }
    },2500);
  }

  updateQuestInfo(){
    this.subscriptionTM = this.whenRefreshTM$.subscribe(()=>{
      this.questInfo = JSON.parse(sessionStorage.getItem('QuestInfo') as string);
      this.ref.markForCheck();
    })
  }

  updateAllInfo(){
    this.subscription = this.whenRefresh$.subscribe(()=>{
      if(this.rdUse.game$){

        this.realPlayers = this.rdUse.game$?.players;
        this.roomInfo = this.rdUse.game$;
      }
      this.ref.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
      if(this.subscriptionTM){
        this.subscriptionTM.unsubscribe();
      }
    if(this.subscriptionDW){
      this.subscriptionDW.unsubscribe();
    }

  }

  userWait(players: number): boolean{
    let isWait: boolean = false;
    if(players > this.realPlayers.length){
      isWait = true;
    }else{     
      this.realPlayers.forEach((item:any)=>{
        if(!item.is_ready){
          isWait = true;
        }
      });
    }
    
    return isWait;
  }

  showText(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop'; 
    dialogConfig.data = {text: this.questInfo.data.humman_description.text};
    const dialogRef = this.dialog.open(InfoQuestRole, dialogConfig);
  }

  isTwoPlayersIsReady(){
    let isReady: boolean = false;
    let countReady: number = 0;
    this.realPlayers.forEach((player: any) => {
      if(player.is_ready) {
        countReady++;
      }
    });
    if(countReady >= 2) {
      isReady = true;
    }
    return isReady;
  }

}
